<template>
  <div class="page-content">
    <table-logement-proximite />
    <div class="q-mt-sm">
      <div class="comment">
        <el-textarea
          :parent_data="
            active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
          "
          property="commentaire"
          :editable="true"
          height="90px"
          overflow_edit="hidden scroll"
          placeholder="Préciser"
        />
      </div>
    </div>

    <div>
      <el-title :index="index + 2" :parent_data="active_study.etudeData.gie.sectionCapaciteFinanciereMenages"
            property="titre"
            :editable="true" style="margin-bottom: 5px">
        Capacités financières des ménages&nbsp;:
      </el-title>

      <el-edit-mode theme="budget">
        <div class="box-edit-line">
            <label>Taux d'intêret</label>
          <div class="flex">
            <el-textarea
              :parent_data="active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel"
              :property="'tauxInteret'"
              :editable="true"
              placeholder="ex: 10"
              style="flex: 1 1 auto;"
              class="q-mr-sm"
            />
            %
          </div>
        </div>
        <div class="box-edit-line">
          <label>Durée d'emprunt</label>
          <div class="flex">
            <el-textarea
              :parent_data="active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel"
              :property="'dureeEmprunt'"
              :editable="true"
              placeholder="ex: 25"
              style="flex: 1 1 auto;"
              class="q-mr-sm"
            />
            années
          </div>
        </div>
      </el-edit-mode>

      <div>
		<error v-if="budgetTableError" />
		<div v-else>
			<table-capacite-financiere-menage @ErrorTableBudget="errorTableBudget" />
		</div>
        <div> Budget maximum calculé sur la base d'un taux d'intérêt de {{this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel.tauxInteret}}% et d'une durée d'emprunt de {{this.active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel.dureeEmprunt}} ans. </div>
      </div>
	
		<el-title :index="index + 3" :parent_data="active_study.etudeData.gie.sectionSynthesePreconisations"
			property="titre"
			:editable="true" style="margin-bottom: 5px">
			Synthèse et préconisations&nbsp;:
		</el-title>
		<section-synthese-preconisation />
	</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";


import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import sectionSynthesePreconisation from "@/components/study/editor/pages/sections/section-synthese-preconisation";
import TableLogementProximite from "@/components/study/editor/elements/data/table/table-logement-proximite";
import TableCapaciteFinanciereMenage from "@/components/study/editor/elements/data/table/table-capacite-financiere-menage";


export default {
	name: "page-gie-3",
	mixins: [PageMixin],
	data: function () {
		return {
			form: {},
			budgetTableError: false,
		};
	},
	props: ["index"],
	computed: {
		...mapGetters([
			"active_study",
			"etude_data",
			"app_parameters",
			"editor",
		]),
	},
	components: {
		sectionSynthesePreconisation,
		TableLogementProximite,
		TableCapaciteFinanciereMenage
	},
	methods: {
		errorTableBudget (){
			this.budgetTableError=true;
		}
	}
};
</script>

<style lang="stylus">
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';

.line-box-negative-margin-top {
  margin-top -30px
  right -500px !important
}
</style>
